import { backendURL, postRestURL } from "../utils/constants/constants";

export async function postCollaboration({ collaborationBody, token }) {
    try {
        const response = await fetch(`${backendURL}/colaboration/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(collaborationBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function putCollaboration({ collaborationBody, token }) {
    try {
        const response = await fetch(`${backendURL}/colaboration/update`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(collaborationBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getActiveCollaborationByInfluencer({ influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/activecolaborations?influencerid=eq.${influencerId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getNotActiveCollaborationByInfluencer({ influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/pastcolaborations?influencerid=eq.${influencerId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getActiveCollaborationByCompany({ companyId }) {
    try {
        const response = await fetch(`${postRestURL}/activecolaborations?companyid=eq.${companyId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getNotActiveCollaborationByCompany({ companyId }) {
    try {
        const response = await fetch(`${postRestURL}/pastcolaborations?companyid=eq.${companyId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


/* export async function getCartCollaboration({ companyId }) {
    try {
        const response = await fetch(`${postRestURL}/colaboration?select=*,influencer!influincr(imageprofile), product(image)&status=eq.0&company=eq.${companyId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
} */
export async function getCartCollaboration({ token }) {

    try {
        const response = await fetch(`${backendURL}/colaboration/shopppingCart`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCollaborationById({ collaborationId, token }) {

    try {
        const response = await fetch(`${backendURL}/colaboration/${collaborationId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });

        let data = { message: 'error' }

        if (response.status === 200) {
            data = await response.json();
        }

        return data;


    } catch (e) {
        throw (e);
    }
}

export async function getCollaborationItemsById({ collaborationId }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/recoveritems?colaborationid=${collaborationId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function putCollaborationStatus({ collaborationId, newStatus, token }) {
    try {
        const response = await fetch(`${backendURL}/colaboration/updStatusColInfluencer/${collaborationId}/${newStatus}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function deleteCollaboration({ collaborationId, token }) {
    try {
        const response = await fetch(`${backendURL}/colaboration/${collaborationId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function putContentCollaborationStatus({ contentId, newStatus, token }) {
    try {
        const response = await fetch(`${backendURL}/colaboration/updStatusContentInfluencer/${contentId}/${newStatus}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function putContentCollaboration({ contentBody, token }) {
    try {
        const response = await fetch(`${backendURL}/colaboration/updateContentItem`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(contentBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getContentCollaboration({ collaborationId }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/recoveritems?colaborationid=${collaborationId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getContentCollaboration2({ collaborationId }) {

    try {
        const response = await fetch(`${postRestURL}/item?colaboration=eq.${collaborationId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postContentCollaboration({ contentBody }) {

    try {
        const response = await fetch(`${postRestURL}/item`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            },
            body: JSON.stringify(contentBody)
        });
        return response;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function deleteContentCollaboration({ contentId }) {

    try {
        const response = await fetch(`${postRestURL}/item?id=eq.${contentId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        return response;
    } catch (e) {
        throw (e);
    }
}



export async function postDispute({ disputeBody, token }) {
    try {
        const response = await fetch(`${backendURL}/dispute`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(disputeBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function getRatePendingInfluencer({ influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/rpc/pendingratinginfluencer?id_influencer=${influencerId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postRateInfluencer({ rateBody, token }) {
    try {
        const response = await fetch(`${backendURL}/rating/influencer`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(rateBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function getRatePendingCompany({ companyId }) {
    try {
        const response = await fetch(`${postRestURL}/rpc/pendingratingcompany?id_company=${companyId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postRateCompany({ rateBody, token }) {

    try {
        const response = await fetch(`${backendURL}/rating/company`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(rateBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function getCollaborationsByCompanyIdAndStatus({ companyId, status }) {

    try {
        const response = await fetch(`${postRestURL}/profilecolaborations?company_id=eq.${companyId}&status=eq.${status}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCollaborationsByInfluencerIdAndStatus({ influencerId, status }) {

    try {
        const response = await fetch(`${postRestURL}/profilecolaborations?influencer_id=eq.${influencerId}&status=eq.${status}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function patchCollaboration({ collaborationId, collaborationBody }) {

    try {
        const response = await fetch(`${postRestURL}/colaboration?id=eq.${collaborationId}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            },
            body: JSON.stringify(collaborationBody)
        });
        return response;
    } catch (e) {
        throw (e);
    }
}


export async function getCollaboratorsByInfluencer({ influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/collaborators?influencerid=eq.${influencerId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}
